// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThumbLikeButton_wrapper__lgbU8","icon":"ThumbLikeButton_icon__a7Ppu","count":"ThumbLikeButton_count__vnhC_"};